import Router from 'lib/Router';

import ManageView from 'view/visit/manage';
import VisitView from 'view/visit/view';
import IndexView from 'view/visit/index';
import MineView from 'view/visit/mine';

import Pond from 'model/Pond';
import Visit from 'model/Visit';
import VisitList from 'model/VisitList';
import config from 'config';
import * as repo from 'db/repositories';
import { loadPondPage } from 'db/persist';

export default Router.extend({
	routes: {
		'visit/create/:id': 'executeCreate',
		'visit/view/:id': 'executeView',
		'visit/manage/:id': 'executeManage',

		'visit/sent': 'executeSent',
		'visit/draft': 'executeDraft',
		'visit/mine(/:page)': 'executeMine',
	},

	unsecure: [ 'executeView' ],


	// création d'une visite (id=pond)
	executeCreate: function( id )
	{
		loadPondPage( id ).then( function( pond )
		{
			if( !pond )
			{
				return console.error404();
			}

			var user = app.getStore('user');

			var visit = new Visit;
			visit.setPond( pond );
			visit.setUser( user );
			visit._pond = pond;

			var view = new ManageView({
				model: visit
			});

			app.render( view );
		} ).catch( function()
		{
			console.error404();
		} );
	},

	executeView: function( id )
	{
		repo.getVisit( id ).then( function( attrs )
		{
			if( !attrs || attrs.todo === 'delete' )
			{
				return console.error404();
			}

			var visit = new Visit( attrs, { parse: true } );

			return loadPondPage( visit.get( 'pond_uuid' ) ).then( function( pond )
			{
				if( !pond )
				{
					return console.error404();
				}

				visit._pond = pond;

				var view = new VisitView({
					model: visit
				});

				app.render( view );
				app.history.push( Backbone.history.getHash() );
			} );
		} ).catch( function()
		{
			console.error404();
		} );
	},


	executeManage: function( id )
	{
		repo.getVisit( id ).then( function( attrs )
		{
			if( !attrs || attrs.todo === 'delete' )
			{
				return console.error404();
			}

			var visit = new Visit( attrs, { parse: true } );

			return loadPondPage( visit.get( 'pond_uuid' ) ).then( function( pond )
			{
				if( !pond )
				{
					return console.error404();
				}

				visit._pond = pond;

				if( !visit.isNew() && visit.get('user_uuid') != app.getStore('user').get('uuid') )
				{
					app.addMessage("Vous n'êtes pas autorisé à modifier cette visite",'error');
					return app.redirect( visit.toUrl('visit/view') );
				}

				var view = new ManageView({
					model: visit
				});

				app.render( view );
			} );
		} ).catch( function()
		{
			console.error404();
		} );
	},

	_renderVisitIndex: function( type )
	{
		var userId = app.getStore('user').get('id');
		var collection = new VisitList();

		repo.getVisitsByType( type, userId ).then( function( rows )
		{
			collection.reset( rows, { silent: true, parse: true } );

			var view = new IndexView({
				collection: collection
			});
			view.type = type;

			app.render( view );
			app.history.push( Backbone.history.getHash() );
		} );
	},

	executeSent: function()
	{
		this._renderVisitIndex( 'sent' );
	},

	executeDraft: function()
	{
		this._renderVisitIndex( 'draft' );
	},

	// Liste paginée des visites de l'utilisateur connecté
	executeMine: function( page )
	{
		var userUuid = app.getStore( 'user' ).get( 'uuid' );
		var pageSize = config.page_size;
		var requested = parseInt( page, 10 );

		// Page invalide ou < 1 → page 1
		if( !requested || requested < 1 )
		{
			requested = 1;
		}

		repo.getVisitsByUser( userUuid, {
			offset: ( requested - 1 ) * pageSize,
			limit: pageSize,
		} ).then( function( result )
		{
			var maxPage = Math.max( 1, Math.ceil( result.total / pageSize ) );

			// Page trop grande → rediriger vers la dernière page
			if( requested > maxPage )
			{
				return app.redirect( 'visit/mine/' + maxPage );
			}

			var collection = new VisitList();
			collection.reset( result.items, { silent: true, parse: true } );

			var view = new MineView({
				collection: collection,
			});
			view.page = requested;
			view.total = result.total;

			app.render( view );
			app.history.push( Backbone.history.getHash() );
		} );
	},

});
